import _ from "lodash";
import { injectReducer } from "store/reducers";
import AssessmentCriteria from "AssessmentCriteria";
import StudentProfileTemplates from "Administrator/commonComponents/StudentProfileTemplates";
import EvaluationCriteria from "EvaluationCriteria";
import SubjectsSetup from "./routes/SubjectsSetup";
import AssessmentToolSetup from "AssessmentToolSetup";
import LearnerProfilesSetup from "./routes/LearnerProfilesSetup";
import ConceptsSetup from "./routes/ConceptsSetup";
import ManageTemplates from "Administrator/commonComponents/ManageTemplates";
import RoutineAndMealTemplates from "Administrator/commonComponents/RoutineAndMealTemplates";
import FieldsConfiguration from "Administrator/commonComponents/FieldsConfiguration";
import AdminScopeAndSequence from "./routes/AdminScopeAndSequence";
import AdminATLs from "./routes/AdminATLs";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import Continuum from "Continuum";
import ScoreCategories from "ScoreCategories";
import { updateChildRoutes } from "Administrator/modules/AdministratorModule";
import LocalGrades from "Administrator/commonComponents/LocalGrades";
import GradingPeriods from "Administrator/commonComponents/GradingPeriods";
import GradingPeriodsV3 from "Administrator/commonComponents/GradingPeriodsV3";
import GradingSetup from "Administrator/commonComponents/GradingSetup";
import GradingSetupV2 from "Administrator/commonComponents/GradingSetupV2";
import AssessmentSettingsEvaluationCriteria from "Administrator/commonComponents/AssessmentSettingsEvaluationCriteria";
import GpaAndCredits from "Administrator/commonComponents/GpaAndCredits";
import PlannerElementSetConfiguration from "Administrator/commonComponents/PlannerElementSetConfiguration";
import SubjectStandardsV2 from "Administrator/commonComponents/SubjectStandardsV2";
import Datasets from "Datasets";
import ActionSetup from "./routes/ActionSetup";
import WorkbookTemplates from "../../commonComponents/WorkbookTemplates";
export default store => ({
  path: "academicSetup",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-academicSetup" */ "./components"),
        import(
          /* webpackChunkName: "admin-academicSetup" */ "./modules/AcademicSetupModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "academicSetup",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  onEnter(nextState, replace) {
    const { routes } = nextState;
    const pathname = _.get(nextState, "location.pathname");
    if (_.includes(pathname, "/evaluationCriteria")) {
      const updatedPathname = _.replace(
        pathname,
        "/evaluationCriteria",
        "/evaluation-criteria"
      );
      return replace(updatedPathname);
    }
    store.dispatch(
      updateChildRoutes({
        routes,
        path: "academicSetup",
        pathId: "PYP_ACADEMIC_SETUP",
        type: "replace",
      })
    );
  },
  childRoutes: [
    StudentProfileTemplates(store),
    AssessmentCriteria(store),
    EvaluationCriteria(store),
    AdminATLs(store),
    SubjectsSetup(store),
    LearnerProfilesSetup(store),
    ConceptsSetup(store),
    ActionSetup(store),
    AssessmentToolSetup(store),
    PlannerElementSetConfiguration(store),
    FieldsConfiguration(store),
    ManageTemplates(store),
    RoutineAndMealTemplates(store),
    AdminScopeAndSequence(store),
    SubjectStandardsV2(store),
    Datasets(store),
    Continuum(store),
    ScoreCategories(store),
    LocalGrades(store),
    GradingPeriods(store),
    GradingPeriodsV3(store),
    GradingSetup(store),
    AssessmentSettingsEvaluationCriteria(store),
    GpaAndCredits(store),
    WorkbookTemplates(store),
    GradingSetupV2(store),
  ],
});
